import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store'

export const getSettingByKey = createSelector(
	(state: RootState) => state.user.settingList,
	(_: RootState, settingName: string) => settingName,
	(appSettings, settingName) => {
		return appSettings.find(
			(i) => String(i.nameSetting) === String(settingName)
		)?.valueSetting
	}
)

export const getSettingById = (idSetting: number) => (state: RootState) =>
	state.user.settingList.find((i) => +i.idSetting === +idSetting)?.valueSetting

export const selectUserInfo = (state: RootState) => state.user.user

export const selectUserProps = (state: RootState) => state.user.userProperties

export const selectUserLayerList = (state: RootState) => state.user.layerList

export const selectUserMapBoundBox = (state: RootState) =>
	state.user.user?.boundBox

export const selectSchemeLayer = createSelector(
	(state: RootState) => state.user.layerList,
	(state: RootState) => selectSchemeLayerId(state),
	(layerList, idLayer) => {
		return layerList?.find((i) => String(i.id) === String(idLayer))
	}
)

export const selectSchemeLayerId = (state: RootState) => {
	return getSettingByKey(state, 'ID_TOPO_LAYER')
}

export const selectBaseLayers = createSelector(
	(state: RootState) => state.user.layerList,
	(state: RootState) => selectSchemeLayerId(state),
	(layerList, schemeLayerId) => {
		let layers = layerList.filter(
			(i) => !i.autoload && String(i.type) !== '0' && i.isHistorical
		)

		if (schemeLayerId !== undefined) {
			layers = layers.filter((i) => String(i.id) !== String(schemeLayerId))
		}

		return layers
	}
)

export const selectOverlayLayers = createSelector(
	(state: RootState) => state.user.layerList,
	(state: RootState) => selectSchemeLayerId(state),
	(layerList, schemeLayerId) => {
		let layers = layerList.filter(
			(i) => !i.autoload && String(i.type) !== '0' && !i.isHistorical
		)

		if (schemeLayerId !== undefined) {
			layers = layers.filter((i) => String(i.id) !== String(schemeLayerId))
		}

		return layers
	}
)

export const selectAutoloadLayers = createSelector(
	(state: RootState) => state.user.layerList,
	(state: RootState) => selectSchemeLayerId(state),
	(layerList, schemeLayerId) => {
		let layers = layerList.filter((i) => !!i.autoload && String(i.type) !== '0')

		if (schemeLayerId !== undefined) {
			layers = layers.filter((i) => String(i.id) !== String(schemeLayerId))
		}

		return layers
	}
)
